import { IconButton } from '@material-ui/core';
import Breadcrumbs from '@material-ui/core/Breadcrumbs';
import Tooltip from '@material-ui/core/Tooltip';
import Typography from '@material-ui/core/Typography';
import { GridOverlay } from '@material-ui/data-grid';
import EditOutlinedIcon from '@material-ui/icons/EditOutlined';
import React, { useContext, useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import AppContext from '../../../App/AppContext';
import { SecondaryButton } from '../../../Core/FormInput/index';
import DataGridComp from '../../../Core/Grid';
import AddReportingCodesModal from './AddUpdateModal';
import { getReportingCodes } from '../../../Core/Service/ReportingCodes-service';

const ReportingCodes = (props) => {
    const [state, setState] = useState({
        rows: [],
        show: false,
        ReportingCodesDetails: [],
    });
    const { showToast } = useContext(AppContext);

    useEffect(async () => {
        pullReportingCodesAndUpdateState();
    }, []);

    const handleUpdate = (params) => {
        setState((st) => {
            const nst = {
                ...st,
                show: true,
                ReportingCodesDetails: params.value.row
            };
            return nst;
        });
    };

    const Arrow = (params) => {
        return (
            <>
                <Tooltip title="Update Reporting Codes" aria-label="add">
                    <IconButton size="small" onClick={() => handleUpdate(params)}>
                        <EditOutlinedIcon color="secondary" fontSize="small" />
                    </IconButton>
                </Tooltip>
            </>
        );
    };

    const column_new = [
        {
            field: '',
            headerName: 'Action',
            sortable: false,
            width: 120,
            renderCell: (params) => <Arrow value={params} />
        },
        {
            field: 'id', //reportingCode
            headerName: 'Reporting Code',
            width: 200
        },
        {
            field: 'reportCodeDescription',
            headerName: 'Report Code Description',
            flex: 1
        }
    ];

    const pullReportingCodesAndUpdateState = async () => {
        let result = await getReportingCodes();

        if (result.success) {
            setState((st) => ({
                ...st,
                rows: result.data.list.map((w) => ({
                    ...w,
                    id: w.reportingCode,
                    reportCodeDescription: w.reportCodeDescription
                })),
                show: false,
            }));
        }
        if (!result.success) {
            showToast(result.message);
        }
    };

    const handleAdd = (props) => {
        setState((st) => {
            return {
                ...st,
                show: true,
                ReportingCodesDetails: null
            };
        });
    };

    function CustomNoRowsOverlay() {
        return (
            <GridOverlay>
                <div>No Reporting Codes Available</div>
            </GridOverlay>
        );
    }

    const closeUpdateUser = (refreshGrid) => {
        setState((st) => ({ ...st, show: false }));
        refreshGrid && pullReportingCodesAndUpdateState();
    };

    return (
        <div style={{ position: 'relative' }}>
            <div style={{ position: 'absolute', right: 0 }}>
                <SecondaryButton variant="contained" color="secondary" onClick={handleAdd} className="btnadd">
                    Add Reporting Code
                </SecondaryButton>
            </div>
            {state.show ? <AddReportingCodesModal onFormSubmit={closeUpdateUser} ReportingCodesDetails={state.ReportingCodesDetails} /> : null}
            <Breadcrumbs separator=">>" aria-label="breadcrumb">
                <Link color="inherit" to={'/'}>
                    Home
                </Link>
                <Typography color="secondary" style={{ fontSize: '0.85rem' }}>
                    Reporting Codes
                </Typography>
            </Breadcrumbs>
            <DataGridComp rows={state.rows} columns={column_new} enableSearch={true} offset={250} CustomNoRowsOverlay={CustomNoRowsOverlay} />
        </div>
    );
};
export default ReportingCodes;
